export default __webpack_public_path__ + "static/media/english-to-greek-screenshot-01.19aa8de1.png";